import { createI18n } from 'vue-i18n'
import services from '@/services';
import { useL10NStore} from '@/stores/i18n.store';

let i18n;

let i18nStore;
function initI18n() {
  i18nStore =  useL10NStore();
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: services.i18n.getShortLocale(),
    fallbackWarn: false,
    missingWarn: false,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocalMessages()
  });
  i18nStore.seti18n(i18n);

  return Promise.resolve();
}

function loadLocalMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.js$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default
    }
  });
  return messages;
}

function getCatalog(catalogId, service, alias = null) {
  let myService = service ? service : undefined;
  let catalogEntry = alias ? alias : catalogId;
  let locale = services.i18n.getShortLocale();
  return services.i18n.getCatalogAsync(catalogId, myService, alias);
}

export {i18n as default, initI18n};
